import { render, staticRenderFns } from "./MotorbikeDamage.vue?vue&type=template&id=8dab04d4"
import script from "./MotorbikeDamage.vue?vue&type=script&lang=js"
export * from "./MotorbikeDamage.vue?vue&type=script&lang=js"
import style0 from "./MotorbikeDamage.vue?vue&type=style&index=0&id=8dab04d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports